import React from "react";

import CampaignPreview from "../components/marketing/CampaignPreview";
import CampaignAnalytics from "../components/marketing/CampaignAnalytics";

const CampaignDetails = () => {

    const campaign = {

        title: "Weekend Sale",
        description: "Flat 20% OFF",
        campaignType: "Coupon",
        targetAudience: "All Customers",
        status: "Running",
        impressions: 2500,
        clicks: 420,
        conversions: 95,
        revenue: 18000,

    };

    return (

        <div className="marketing-page">

            <CampaignPreview campaign={campaign} />

            <CampaignAnalytics
                analytics={{
                    impressions: campaign.impressions,
                    clicks: campaign.clicks,
                    conversions: campaign.conversions,
                    revenue: campaign.revenue,
                }}
            />

        </div>

    );

};

export default CampaignDetails;